import { render, staticRenderFns } from "./standardSwitchChild.vue?vue&type=template&id=4b91bdd0&scoped=true&"
import script from "./standardSwitchChild.vue?vue&type=script&lang=js&"
export * from "./standardSwitchChild.vue?vue&type=script&lang=js&"
import style0 from "./standardSwitchChild.vue?vue&type=style&index=0&id=4b91bdd0&lang=scss&scoped=true&"
import style1 from "./standardSwitchChild.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b91bdd0",
  null
  
)

export default component.exports